import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" id=\"icon-search\"><path d=\"M8.31 6.896l3.397 3.397a1 1 0 0 1-1.414 1.414L6.896 8.31A4.5 4.5 0 1 1 8.31 6.896zM4.5 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol